import pages from './pages';
import common from './common.json';
import components from './components';

export default { pages, common, components };
